<template>

  <div class="modal fade" id="modal_browser" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content" v-if="fiche_member?.member_info">
        <div class="modal-header">
          <h5 class="modal-title" id="varyingModalLabel">
            {{ i18n.t("layout.navbar.modal.member.title") }}
            <element-status :status="fiche_member?.member_info?.subscription_status ?? false" />
          </h5>
          <button @click="closeModal('modal_browser', 'add')" type="button" class="btn-close"
            aria-label="btn-close"></button>
        </div>
        <div class="modal-body">
          <div v-if="fiche_member?.active_subscription && fiche_member?.member_info?.subscription_status"
            class="row height-100">
            <!-- Subscription paused, but we get the object of active_subscription -->
            <div v-if="fiche_member?.member_info?.subscription_status == 'paused'" class="col-md-12">
              <div class="message message-paused ">
                <p><b> {{ i18n.t('views.clients.member_fiche.subscription_status.paused.title') }}</b>
                </p>
                <p>
                  {{ i18n.t('views.clients.member_fiche.subscription_status.paused.description') }}
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="fiche_member?.member_info?.subscription_status == 'expired'" class="row">
            <div class="col-md-12">
              <div class="message message-expired">
                <p><b> {{ i18n.t('views.clients.member_fiche.subscription_status.expired.title') }}</b>
                </p>
                <p>
                  {{ i18n.t('views.clients.member_fiche.subscription_status.expired.description') }}
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="fiche_member?.member_info?.subscription_status == 'no_sessions_left'" class="row">
            <div class="col-md-12">
              <div class="expired-message">
                <p><b> {{ i18n.t('views.clients.member_fiche.subscription_status.no_sessions_left.title') }}</b>
                </p>
                <p>
                  {{ i18n.t('views.clients.member_fiche.subscription_status.no_sessions_left.description') }}
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="fiche_member?.member_info?.subscription_status == 'no_points_left'" class="row">
            <div class="col-md-12">
              <div class="message message-expired">
                <p><b> {{ i18n.t('views.clients.member_fiche.subscription_status.no_points_left.title') }}</b>
                </p>
                <p>
                  {{ i18n.t('views.clients.member_fiche.subscription_status.no_points_left.description') }}
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="fiche_member?.member_info?.subscription_status == 'canceled'" class="row">
            <div class="col-md-12">
              <div class="message message-canceled">
                <p><b> {{ i18n.t('views.clients.member_fiche.subscription_status.canceled.title') }}</b>
                </p>
                <p>
                  {{ i18n.t('views.clients.member_fiche.subscription_status.canceled.description') }}
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="fiche_member?.member_info?.subscription_status == 'not_started'" class="row">
            <div class="col-md-12">
              <div class="message message-not_started">
                <p><b> {{ i18n.t('views.clients.member_fiche.subscription_status.not_started.title') }}</b>
                </p>
                <p>
                  {{ i18n.t('views.clients.member_fiche.subscription_status.not_started.description') }}
                </p>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-md-12">
              <div class="message message-expired">
                <p><b> {{ i18n.t('views.clients.member_fiche.subscription_status.none.title') }}</b>
                </p>
                <p>
                  {{ i18n.t('views.clients.member_fiche.subscription_status.none.description') }}
                </p>
              </div>
            </div>
          </div>

          <div class="row d-flex justify-content-center align-items-center">


            <div class="col-12 col-lg-4">
              <div class="card-img qr-code" style="width: 50%;">
                <path-image class="profile-img fit-cover img-fluid w-100"
                  :path_image="fiche_member?.member_info?.path_image ?? `${fiche_member?.member_info?.gender == 0 ? 'female.png' : 'male.png'}`" />

              </div>
            </div>
            <div class="col-12 col-lg-8">
              <div class="row">
                <div v-if="fiche_member?.member_info?.name" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.name") }} </b>: {{
                      fiche_member?.member_info?.name }}
                  </p>
                </div>
                <div v-if="fiche_member?.member_info?.parent_name" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.parent_name") }} </b>: {{
                      fiche_member?.member_info?.parent_name }}
                  </p>
                </div>
                <div v-if="hasPermission('download_contract') && fiche_member?.active_subscription?.contractNumber"
                  class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.contractNumber") }}
                    </b>
                    :<span class="actif">
                      {{ fiche_member?.active_subscription?.contractNumber }}
                    </span>
                  </p>
                </div>
                <div v-if="fiche_member?.member_info?.matricule" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.matricule") }} </b>:
                    <span class="actif">
                      {{ fiche_member?.member_info?.matricule }}
                    </span>
                  </p>
                </div>
                <div v-if="fiche_member?.member_info?.cin" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.cin") }}
                    </b>
                    :<span class="actif">
                      {{ fiche_member?.member_info?.cin }}
                    </span>
                  </p>
                </div>
                <div v-if="fiche_member?.member_info?.occupation" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.occupation") }}
                    </b>
                    :<span class="actif">
                      {{ fiche_member?.member_info?.occupation }}
                    </span>
                  </p>
                </div>
                <div v-if="fiche_member?.member_info?.dateBirth" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.dateBirth") }} </b>: {{
                      formatDate(fiche_member?.member_info?.dateBirth) }}
                  </p>
                </div>
                <div v-if="fiche_member?.member_info?.dateBirth" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.dateBirth") }} </b>: {{
                      calculateAge(fiche_member?.member_info?.dateBirth) }}
                  </p>
                </div>
                <div v-if="fiche_member?.member_info?.email" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.email") }} </b>: {{
                      fiche_member?.member_info?.email }}
                  </p>
                </div>
                <div v-if="fiche_member?.member_info?.tele" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.tele") }}
                    </b>
                    :<span class="actif">
                      {{ fiche_member?.member_info?.tele }}
                    </span>
                  </p>
                </div>
                <div v-if="fiche_member?.member_info?.adresse" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.adresse") }}
                    </b>
                    :<span class="actif">
                      {{ fiche_member?.member_info?.adresse }}
                    </span>
                  </p>
                </div>
                <div v-if="fiche_member?.member_info?.comment" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.comment") }}
                    </b>
                    :<span class="actif">
                      {{ fiche_member?.member_info?.comment }}
                    </span>
                  </p>
                </div>

                <div v-if="fiche_member?.member_info?.seller?.name" class="col-md-12 mb-2">
                  <p class="timeline-content">
                    <b class="d-inline-block w-160">{{ i18n.t("tables.members.seller") }} </b>: {{
                      fiche_member?.member_info?.seller?.name }}
                  </p>
                </div>
              </div>
            </div>

          </div>
          <div class="row mt-5">
            <div v-if="hasPermission('fiche_member') && fiche_member?.member_info?.uuid"
              class="col-lg-4 col-md-6 col-sm-6">
              <div class="btn btn-primary w-100 mb-4 text-left" @click="
                navigateTo({
                  name: 'fiche',
                  params: {
                    clubUUID: clubUUID,
                    memberUUID: fiche_member?.member_info?.uuid,
                  },
                })
                ">
                <font-awesome-icon icon="user" size="lg" class="link-icon" />
                {{ i18n.t("layout.navbar.modal.member.fiche") }}
              </div>
            </div>

            <div v-if="
              (!fiche_member?.active_subscription && hasPermission('renewal') && fiche_member?.member_info?.subscription_status !== 'paused') || (hasPermission('can_renew_subscription_with_debt') && hasPermission('renewal'))
            " class="col-lg-4 col-md-6 col-sm-6">
              <div class="btn btn-primary w-100 mb-4 text-left" @click="
                navigateTo({
                  name: 'renew-member-subscription',
                  params: {
                    clubUUID: clubUUID,
                    memberUUID: fiche_member?.member_info?.uuid,
                  },
                })
                ">
                <font-awesome-icon icon="user" size="lg" class="link-icon" />
                {{ i18n.t("button.renew_subscription") }}
              </div>
            </div>




            <div v-if="
              fiche_member?.active_subscription?.remaining_amount > 0 &&
              hasPermission('impayes')
            " class="col-lg-4 col-md-6 col-sm-6">
              <div class="btn btn-primary w-100 mb-4 text-left" @click="
                navigateTo({
                  name: 'impayes',
                  params: {
                    subscriptionID: fiche_member?.active_subscription?.id,
                    clubUUID: clubUUID,
                    memberUUID: fiche_member?.member_info?.uuid,
                  },
                })
                ">
                <font-awesome-icon icon="dollar" size="lg" class="link-icon" />
                {{
                  i18n.t("layout.navbar.modal.member.pay_active_subscription")
                }}
              </div>
            </div>

            <div v-if="hasPermission('credits')" class="col-lg-4 col-md-6 col-sm-6">
              <div class="btn btn-primary w-100 mb-4 text-left" @click="
                navigateTo({
                  name: 'credits-member',
                  params: {
                    clubUUID: clubUUID,
                    memberUUID: fiche_member?.member_info?.uuid,
                  },
                })
                ">
                <font-awesome-icon icon="money-check-dollar" size="lg" class="link-icon" />
                {{ i18n.t("layout.navbar.modal.member.credits") }}
              </div>
            </div>
            <div v-if="hasPermission('transactions')" class="col-lg-4 col-md-6 col-sm-6">
              <div class="btn btn-primary w-100 mb-4 text-left" @click="
                navigateTo({
                  name: 'encaissements-member',
                  params: {
                    clubUUID: clubUUID,
                    memberUUID: fiche_member?.member_info?.uuid,
                  },
                })
                ">
                <font-awesome-icon icon="dollar" size="lg" class="link-icon" />
                {{ i18n.t("layout.navbar.modal.member.history_paymets") }}
              </div>
            </div>
            <div v-if="hasPermission('historiques_subscriptions')" class="col-lg-4 col-md-6 col-sm-6">
              <div class="btn btn-primary w-100 mb-4 text-left" @click="
                navigateTo({
                  name: 'historiques-subscriptions-member',
                  params: {
                    clubUUID: clubUUID,
                    memberUUID: fiche_member?.member_info?.uuid,
                  },
                })
                ">
                <font-awesome-icon icon="history" size="lg" class="link-icon" />
                {{ i18n.t("layout.navbar.modal.member.history_subscriptions") }}
              </div>
            </div>
            <div v-if="hasPermission('payments_stats')" class="col-lg-4 col-md-6 col-sm-6">
              <div class="btn btn-primary w-100 mb-4 text-left" @click="
                navigateTo({
                  name: 'member-reporting-cashflow-incomes',
                  params: {
                    clubUUID: clubUUID,
                    memberUUID: fiche_member?.member_info?.uuid,
                  },
                })
                ">
                <font-awesome-icon icon="chart-pie" size="lg" class="link-icon" />
                {{ i18n.t("layout.navbar.modal.member.chart_regulations") }}
              </div>
            </div>
            <div v-if="hasPermission('ca')" class="col-lg-4 col-md-6 col-sm-6">
              <div class="btn btn-primary w-100 mb-4 text-left" @click="
                navigateTo({
                  name: 'member/global-revenu',
                  params: {
                    clubUUID: clubUUID,
                    memberUUID: fiche_member?.member_info?.uuid,
                  },
                })
                ">
                <font-awesome-icon icon="chart-pie" size="lg" class="link-icon" />
                {{ i18n.t("layout.navbar.modal.member.chart_ca") }}
              </div>
            </div>

            <div v-if="
              fiche_member?.active_subscription && fiche_member?.member_info?.subscription_status !== 'paused' && hasPermission('renewal')
            " class="col-lg-4 col-md-6 col-sm-6">
              <div class="btn btn-primary w-100 mb-4 text-left" @click="
                navigateTo({
                  name: 'pause-member-subscription',
                  params: {
                    clubUUID: clubUUID,
                    memberUUID: fiche_member?.member_info?.uuid,
                  },
                })
                ">
                <font-awesome-icon icon="pause" size="lg" class="link-icon" />
                {{ i18n.t("button.pause_subscription") }}
              </div>
            </div>
            <div v-if="
              fiche_member?.active_subscription && fiche_member?.member_info?.subscription_status == 'paused'
            " class="col-lg-4 col-md-6 col-sm-6">
              <div class="btn btn-primary w-100 mb-4 text-left" @click="
                navigateTo({
                  name: 'resume-member-subscription',
                  params: {
                    clubUUID: clubUUID,
                    memberUUID: fiche_member?.member_info?.uuid,
                  },
                })
                ">
                <font-awesome-icon icon="play" size="lg" class="link-icon" />
                {{ i18n.t("button.resume_subscription") }}
              </div>
            </div>
            <div v-if="
              fiche_member?.active_subscription && hasPermission('renewal')
            " class="col-lg-4 col-md-6 col-sm-6">
              <div class="btn btn-primary w-100 mb-4 text-left" @click="
                navigateTo({
                  name: 'cancel-member-subscription',
                  params: {
                    clubUUID: clubUUID,
                    memberUUID: fiche_member?.member_info?.uuid,
                  },
                })
                ">
                <font-awesome-icon icon="cancel" size="lg" class="link-icon" />
                {{ i18n.t("button.cancel_subscription") }}
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import i18n from "@/i18n/index";

import router from "@/router/index";
/*composables & states */
import { userUUID, clubUUID } from "@/shared/state";
import { useModal } from "@/composables/modal/useModal";
import { useGlobal } from "@/composables/global/useGlobal";

import { usePermission } from "@/composables/auth/usePermission";
import { defineProps, toRefs } from "vue";

const props = defineProps({
  fiche_member: {
    type: Object,
    default: null,
  },
});
const { closeModal, openModal } = useModal();
const { fiche_member } = toRefs(props);
const { hasPermission } = usePermission();
const { calculateAge, formatDate } = useGlobal();
const navigateTo = (query) => {
  fiche_member.value = null
  router.push(query);
  closeModal("modal_browser", "add");
};







</script>

<style lang="scss"></style>
